import { render, staticRenderFns } from "./AdminSport.vue?vue&type=template&id=df6a36c2&"
import script from "./AdminSport.vue?vue&type=script&lang=js&"
export * from "./AdminSport.vue?vue&type=script&lang=js&"
import style0 from "./AdminSport.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df6a36c2')) {
      api.createRecord('df6a36c2', component.options)
    } else {
      api.reload('df6a36c2', component.options)
    }
    module.hot.accept("./AdminSport.vue?vue&type=template&id=df6a36c2&", function () {
      api.rerender('df6a36c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminSport.vue"
export default component.exports